import { render, staticRenderFns } from "./im-group-list.vue?vue&type=template&id=78eb99b4"
import script from "./im-group-list.vue?vue&type=script&lang=js"
export * from "./im-group-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78eb99b4')) {
      api.createRecord('78eb99b4', component.options)
    } else {
      api.reload('78eb99b4', component.options)
    }
    module.hot.accept("./im-group-list.vue?vue&type=template&id=78eb99b4", function () {
      api.rerender('78eb99b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/im-group-list.vue"
export default component.exports